import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import PreferredCourierServiceItem from "./PreferredCourierServiceItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {PREFERRED_COURIER_SERVICES} from "../../queries/shipping";


function getItemKey(item) {
  return `${item.get("accountId")}-${item.get("courierId")}-${item.get("countryCode")}-${item.get("service")}`;
}

class PreferredCourierServicesList extends Component {

  render() {
    let {loading, error, preferredCourierServices} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Account Id",
      "Courier",
      "Country",
      "Service"
    ])         
    return (
      <div>
        <Table 
          data={fromJS(preferredCourierServices)} 
          renderer={PreferredCourierServiceItem} 
          onItemClick={this.handleItemClick.bind(this)}
          tableHeader={tableHeader}
          extraClassName="PreferredCourierServicesList"
          getItemKey={getItemKey}
          mode="table"
          showCount={true}
          selected={this.props.selectedId}
          />
      </div>
    )
  }

  handleItemClick(itemData, e, field = "") {
    console.log("click", itemData);
    // if (field === "id") {
    //   e.stopPropagation();
    //   this.props.onIdClick(id);
    //   return;
    // }    
    this.props.onSelectionChange(getItemKey(itemData), itemData.get("accountId"));
  }  
}

const withQuery = graphql(PREFERRED_COURIER_SERVICES, {
  options: (props) => ({
    fetchPolicy: "network-only"
  })
})

export default withQuery(PreferredCourierServicesList);